module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"alreadyMember":"Allerede medlem?","alreadyMemberLogin":"Logg inn"},"en":{"alreadyMember":"Already a member?","alreadyMemberLogin":"Login"}}')
  delete Component.options._Ctor
}
